import type { Template } from "@/types";

export const PO_01_H1_V0: Template[] = [
    {
        id: "po-01-h1v0-01",
        name: "PO 01 - H1V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v0_01.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 179, y: 157, width: 1015, height: 601, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-01-h1v0-02",
        name: "PO 02 - H1V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v0_02.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 78, y: 97, width: 1219, height: 722, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-01-h1v0-03",
        name: "PO 03 - H1V0",
        albumType: "Hr",
        thumbnail: "/thumbnails/PO/po-01-h1_v0_03.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 97, width: 1374, height: 722, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-01-h1v0-04",
        name: "PO 04 - H1V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v0_04.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 177, y: 0, width: 1021, height: 916, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-01-h1v0-05",
        name: "PO 05 - H1V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v0_05.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 67, y: 65, width: 1239, height: 786, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-01-h1v0-06",
        name: "PO 06 - H1V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v0_06.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 1374, height: 916, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-01-h1v0-07",
        name: "PO 07 - H1V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v0_07.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 687, y: 230, width: 687, height: 456, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-01-h1v0-08",
        name: "PO 08 - H1V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v0_08.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 745, y: 269, width: 570, height: 378, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-01-h1v0-09",
        name: "PO 09 - H1V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v0_09.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 230, width: 687, height: 456, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-01-h1v0-10",
        name: "PO 10 - H1V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v0_10.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 59, y: 269, width: 570, height: 378, rotation: 0, imageRotation: 0 }
        ],
    },
];

